<template>
  <div
    class="pop_note"
    id="pop_note"
    style="display:block"
  >
    <div class="popup_close close_note close-animate">
      <a
        href="javascript:void(0);"
        @click="closeNote"
      >
        <close /></a>
    </div>
    <div class="pop_frame">
      <h2 class="title25">כתוב הערה למוצר זה</h2>
      <div class="pop_note_prod clearfix">
        <div class="right cart_img"><img v-bind:src="product.image" /></div>
        <div class="right cart_title_wrap">
          <div class="cart_title" v-html="product.name"></div>
        </div>
      </div>
      <div class="form_input">
        <textarea
          placeholder="הייתי רוצה ש..."
          v-model="note"
        >
         </textarea>
      </div>
      <div class="submit_bt ease">
        <a
          href="javascript:void(0);"
          @click="saveNote"
        >שמור הערה</a>
      </div>
      <div class="green_link">
        <a
          href="javascript:void(0);"
          @click="removeNote"
        >מחק הערה</a>
      </div>
    </div>
  </div>
</template>

<script>
  import close from "../../assets/img/close.svg";
  import store from "../../store";
  export default {
    props: ["product"],
    data() {
      return {
        note: this.product.note ? this.product.note : ""
      };
    },
    mounted() {
    },
    methods: {
      removeNote() {
        this.product.note = "";
        this.product.open_note = "";
        store.commit("updateCart", {
          product: this.product,
          is_edit: true
        });
        this.closeNote();
      },
      saveNote() {
        this.product.note = this.note;
        if (!this.product.quantity) {
          this.product.quantity = 1;
        }
        store.dispatch('updateCart', [this.product]);

        // store.commit("updateCart", {
        //   product: this.product,
        //   is_edit: true
        // });
        this.closeNote();
        this.$modal.hide("prod-modal");
      },
      closeNote() {
        this.$modal.hide("product-note");
      }
    },
    components: {
      close,
      store
    }
  };
</script>
